import React from 'react';

import RenderStaticHTML from '../RenderStaticHTML';

const Square = ({
	id, label, rootClassnames, disabled, checkboxRef, checked, handleChange, ...props
}) => {
	return (
		<label htmlFor={id} className={rootClassnames}>
			<span aria-hidden>
				<svg
					xmlns={`http://www.w3.org/2000/svg`}
					fill={`none`}
					viewBox={`0 0 16 16`}
					width={16}
					height={16}
				>
					{checked ? (
						<>
							<rect
								width={15}
								height={15}
								x={`.5`}
								y={`.5`}
								fill={`currentColor`}
								stroke={`currentColor`}
								rx={`1.5`}
							/>
							<path
								stroke={`#fff`}
								strokeWidth={2}
								d={`M3 8.5 6.0392 11 12 4`}
							/>
						</>
					) : (
						<rect
							width={15}
							height={15}
							x={`.5`}
							y={`.5`}
							stroke={`currentColor`}
							rx={`1.5`}
						/>
					)}
				</svg>
			</span>
			<input
				{...props}
				disabled={disabled}
				id={id}
				ref={checkboxRef}
				type={`checkbox`}
				checked={checked}
				onChange={handleChange}
			/>
			{typeof label === 'string' ? (
				<RenderStaticHTML
					html={label}
					as={`span`}
				/>
			) : (
				<span>{label}</span>
			)}
		</label>
	);
};

export default Square;
